export { extractFromPath, getObjFromQueryString } from './url.es.js';
export { PATTERN_VALIDATION, isValidEmailFormat, isValidPhoneFormat } from './validators.es.js';
export { getWeekdayOfDate } from './date.es.js';
export { htmlDecode, htmlEncode } from './html.es.js';
export { isFloat } from './number.es.js';
export { LOCALSTORAGE_OVER_18_YEARS_OLD, getSessionStorageOver18YearOld, setSessionStorageOver18YearOld } from './storage.es.js';

const normalizePhone = (rawphone) => {
    const phone = rawphone.trim();
    if (phone.length > 10) {
        if (phone.startsWith('84'))
            return phone.replace('84', '0');
        if (phone.startsWith('+84'))
            return phone.replace('+84', '0');
        return phone;
    }
    return phone;
};
const customizedMessage = (message, fields) => {
    let resultMessage = message;
    fields.forEach(({ name, value }) => {
        const regex = new RegExp(`{${name}}`, 'g');
        resultMessage = resultMessage.replace(regex, value);
    });
    return resultMessage;
};
const inIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
const toObject = (arr, keyField) => {
    let newArr = {};
    if (Array.isArray(arr)) {
        for (const key in arr) {
            newArr = Object.assign(Object.assign({}, newArr), { [arr[key][keyField]]: arr[key] });
        }
    }
    return newArr;
};
const cleanObject = (object) => {
    const newObj = {};
    Object.keys(object).forEach((key) => {
        if (object[key] || object[key] === false || object[key] === 0) {
            newObj[key] = object[key];
        }
    });
    return newObj;
};
const formatCurrency = (money, isFull = true) => {
    return `${money || money == 0
        ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        : money}${isFull ? 'đ' : ''}`;
};
function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export { cleanObject, customizedMessage, debounce, formatCurrency, inIframe, normalizePhone, toObject };
